export interface InternationalTopUpOffer {
    id: string;
    productId: string;
    amount: number;
    description: string;
    productShortDescription: string;
    productLongDescription: string;
    categoryId: string;
    categoryName: string;
}
